import { Api_routes, server_url } from '../config/API_Routes';
import { deleteRequest, getRequest, postRequest } from '../config/axios-config';

const searchInfluencersPlatformWise = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.searchPostTrackingInfluencers,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const createPostTrackingCampaign = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      // const response = await postRequest(
      //   server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.createPostTrackingCampaign,
      //   body
      // );
      const response = await postRequest(
        apiv2_server_url + Api_routes.createPulseCampaign,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const fetchIgAccounts = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(server_url + '/facebook/instagram-data');
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const editPostTrackingCampaign = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.editPostTrackingCampaign,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getPostTrackingCampaign = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getPostTrackingCampaign,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getPostTrackingCampaignById = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getPostTrackingCampaignById,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getPostTrackingCampaignStats = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getPostTrackingCampaignStats,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getPostTrackingRevenue = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getPostTrackingRevenue,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getPostTrackingPosts = (body, signal) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getPostTrackingCampaignPosts,
        body,
        undefined,
        signal
      );
      resolve(response);
    } catch (err) {
      if (err.name === 'AbortError') {
        return;
      }
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const updatePostTrackingStatus = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updatePostTrackingStatus,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getCampaignDownloadLinks = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getCampaignDownloadLinks,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const sendUsageRequest = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.sendUsageRequest,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getAllUsageRequests = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getAllUsageRequests,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const remindUsageRequestAgain = (usageRequestId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.remindUsageRequest,
        { usageRequestId }
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const acceptUsageRequest = (usageRequestId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.acceptUsageRequest,
        { usageRequestId }
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getAllLabels = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getPostTrackingLabels
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const createLabel = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.createPostTrackingLabel,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const editLabel = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.editPostTrackingLabel,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const attachLabel = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.attachLabel,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const detachLabel = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.detachLabel,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const deleteLabel = (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await deleteRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.deleteLabel + `/${id}`
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getAllLibraries = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getLibraries,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const createLibrary = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.createLibrary,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const editLibrarySettings = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.editLibrarySettings,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getTrackedImpactChartData = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getTrackedImpactChartData,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getInfluencerDetails = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getPostTrackingInfluencerDetails,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getKeyPerformanceIndicators = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getKeyPerformanceIndicators,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getTotalViewsAcrossPlatforms = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getTotalViewsAcrossPlatforms,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getTopPerformingCreators = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getTopPerformingCreators,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getTopPerformingPosts = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getTopPerformingPosts,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getImpressionsAcrossPlatforms = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getImpressionsAcrossPlatforms,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getContentCountStats = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getContentCountStats,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getEngagementBreakdownStats = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getEngagementBreakdownStats,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

export {
  searchInfluencersPlatformWise,
  createPostTrackingCampaign,
  editPostTrackingCampaign,
  getPostTrackingCampaign,
  getPostTrackingCampaignById,
  getPostTrackingCampaignStats,
  getPostTrackingRevenue,
  getPostTrackingPosts,
  updatePostTrackingStatus,
  getCampaignDownloadLinks,
  sendUsageRequest,
  getAllUsageRequests,
  remindUsageRequestAgain,
  acceptUsageRequest,
  getAllLabels,
  createLabel,
  editLabel,
  attachLabel,
  detachLabel,
  deleteLabel,
  getAllLibraries,
  createLibrary,
  fetchIgAccounts,
  editLibrarySettings,
  getTrackedImpactChartData,
  getInfluencerDetails,
  getKeyPerformanceIndicators,
  getTotalViewsAcrossPlatforms,
  getTopPerformingCreators,
  getTopPerformingPosts,
  getImpressionsAcrossPlatforms,
  getContentCountStats,
  getEngagementBreakdownStats,
};
